import type { WithIParam } from 'libs/apis'
import type { OptionProps } from 'types'
import { ROLE_OPTIONS } from 'helpers/constants/common'

import type { IBranchSinglePropsPartial } from './model'

export const filterParams = (
  searchParams: WithIParam<IBranchSinglePropsPartial>,
): WithIParam<IBranchSinglePropsPartial> => {
  const nextParams = {
    ...searchParams,
  }

  return nextParams
}

export const convertRole = (role: string | boolean | undefined): OptionProps =>
  ROLE_OPTIONS.find(({ key }) => key === role) || ROLE_OPTIONS[0]
